import { createAction, props } from '@ngrx/store'
import { EntityConfiguration, GroupConfig } from '../../modules/dto'

export const loadConfigsRequested = createAction('[Config] load requested')
export const loadConfigsSucceeded = createAction(
  '[Config] loaded configs',
  props<{ configs: Record<string, EntityConfiguration> }>()
)
export const loadGroupConfigsRequested = createAction('[Config] group load requested')
export const loadGroupConfigsSucceeded = createAction(
  '[Config] loaded group-configs',
  props<{ configs: Record<string, GroupConfig> }>()
)
